import { z } from 'zod';
/**
 * LocalTime — a wall-clock time of day (HH:mm, 24-hour) with no timezone
 * and no seconds.
 *
 * Wire format regex: `^([01]\d|2[0-3]):[0-5]\d$`
 *
 * - Hour: 00-23. Minute: 00-59.
 * - No seconds, no fractions, no trailing separator.
 */
export const LocalTimeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'must be HH:mm, 24-hour')
    .brand();
//# sourceMappingURL=local-time.js.map